import { render } from "./TIMESHEET_APPROVED.vue?vue&type=template&id=6dfff23c&ts=true"
import script from "./TIMESHEET_APPROVED.vue?vue&type=script&lang=ts"
export * from "./TIMESHEET_APPROVED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__